import React, { useEffect } from 'react';
import { RecoilRoot, useRecoilSnapshot } from 'recoil';

import Shell from './shell';
import routes from './routes';

// function DebugObserver() {
//   const snapshot = useRecoilSnapshot();
//   useEffect(() => {
//     console.debug("The following atoms were modified:");
//     for (const node of snapshot.getNodes_UNSTABLE({ isModified: true })) {
//       console.debug(node.key, snapshot.getLoadable(node));
//     }
//   }, [snapshot]);

//   return null;
// }

import { AutoRefreshingRouter } from 'Components/shared/';

const App = () => (
  <RecoilRoot>
    <AutoRefreshingRouter>
      <Shell routes={routes} />
    </AutoRefreshingRouter>

    {/* <DebugObserver /> */}

  </RecoilRoot>
)

export default App;
